import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/daily-attendance-report/DailyAttendanceReportAction";
import * as uiHelpers from "../DailyAttendanceReportUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useDailyAttendanceReportUIContext } from "../DailyAttendanceReportUIContext";

export function DailyAttendanceReportTable() {
  // Daily Attendance Report UI Context
  const dailyAttendanceReportUIContext = useDailyAttendanceReportUIContext();
  const dailyAttendanceReportUIProps = useMemo(() => {
    return {
      queryParams: dailyAttendanceReportUIContext.queryParams,
      setQueryParams: dailyAttendanceReportUIContext.setQueryParams
    };
  }, [dailyAttendanceReportUIContext]);

  // Getting curret state of Daily Attendance Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.dailyAttendanceReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Daily Attendance Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getDailyAttendanceReport(dailyAttendanceReportUIProps.queryParams));
    return () => dispatch(actions.cleanDailyAttendanceReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dailyAttendanceReportUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "date",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px",
      }
    },
    {
      dataField: "courseHour",
      text: "Ders Saati",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px",
      }
    },
    {
      dataField: "attendanceStatusName",
      text: "Yoklama Durumu",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "175px",
      }
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px"
      }
    },
    {
      dataField: "advisors",
      text: "Danışman Öğretmenler",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "225px",
      }
    },
    {
      dataField: "teacher",
      text: "Yoklama Alan Öğretmen",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "225px",
      }
    },
    {
      dataField: "parentName",
      text: "Veli Adı Soyadı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px"
      }
    },
    {
      dataField: "parentPhone",
      text: "Veli Telefonu",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: dailyAttendanceReportUIProps.queryParams.pageSize,
    page: dailyAttendanceReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                dailyAttendanceReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}